/**
 * Restrict dragging of a vanilla JS NodeView to a specific handle element.
 *
 * TipTap's `data-drag-handle` convention only works with React NodeViews.
 * For vanilla NodeViews, call this helper to get the same behavior:
 * drag is only allowed when mousedown started on the handle.
 *
 * @param wrapper - The NodeView's `dom` element (has `draggable` set by ProseMirror)
 * @param handle  - The element that should act as the drag handle
 */
const setupDragHandle = (wrapper: HTMLElement, handle: HTMLElement): void => {
  let mousedownOnHandle = false;
  wrapper.addEventListener(
    'mousedown',
    () => {
      mousedownOnHandle = false;
    },
    true
  ); // capture: reset before bubble
  handle.addEventListener('mousedown', () => {
    mousedownOnHandle = true;
  });
  wrapper.addEventListener('dragstart', (e) => {
    if (!mousedownOnHandle) e.preventDefault();
    mousedownOnHandle = false;
  });
};

export default setupDragHandle;
